import React, {FC, ReactNode} from 'react';
import styles from './GalleryLightbox.module.scss';

type GalleryLightboxCustomSourceProps = {
    children?: ReactNode;
};

export const GalleryLightboxCustomSourceTwo: FC = ({children}) => {
    return (
        <div className={styles.galleryLightboxCustomSource} style={{width: '100vw', height: '100vh'}}>
            {children}
        </div>
    );
};
